import React, { useRef } from "react";
import { GripVertical, ImagePlus, Trash2, X } from "lucide-react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export const MAX_SURVEY_QUESTIONS = 5;

export const createImageAsset = (file) => ({
  file,
  preview: URL.createObjectURL(file),
});

export const cloneImageAsset = (imageAsset) => {
  if (!imageAsset) {
    return null;
  }

  if (imageAsset.file) {
    return createImageAsset(imageAsset.file);
  }

  return { ...imageAsset };
};

export const createOption = (text = "") => ({
  id: crypto.randomUUID(),
  text,
  // image,
});

export const createQuestion = (overrides = {}) => ({
  id: crypto.randomUUID(),
  type: "Single Select",
  text: "",
  // image: null,
  options: [createOption(), createOption()],
  ...overrides,
});

export const isChoiceQuestion = (questionType) =>
  questionType === "Single Select" ||
  questionType === "Multi Select" ||
  questionType === "Rating";

export const initialQuestions = [
  createQuestion({
    text: "",
    options: [createOption(""), createOption("")],
  }),
];

export const initialHashtagItems = ["#AI", "#Workplace", "#Technology"];

export const questionTypeOptions = [
  "Single Select",
  "Multi Select",
  "Rating",
  "Open End",
];

export const questionTypePayloadMap = {
  "Single Select": "single_select",
  "Multi Select": "multi_select",
  Rating: "rating",
  "Open End": "open_end",
};

export const genderOptions = [
  { value: 1, label: "Male" },
  { value: 2, label: "Female" },
  { value: 3, label: "Other" },
];

export const ageLimitOptions = [
  // { value: "18-30", label: "18 - 30 Years" },
  // { value: "31-40", label: "31 - 40 Years" },
  // { value: "41-50", label: "41 - 50 Years" },
  // { value: "51-60", label: "51 - 60 Years" },
  // { value: "60-plus", label: "60+ Years" },
  { value: "18-24", label: "18 - 24" },
  { value: "25-34", label: "25 - 34" },
  { value: "35-44", label: "35 - 44" },
  { value: "45-59", label: "45 - 59" },
  { value: "60-plus", label: "60+" },
];

export const dummySurveySummary = {
  surveyTitle: "Survey Title Here",
  surveyDescription: "Survey Description Here",
  surveyTargetResponses: "0",
  surveyStartDate: "",
  surveyEndDate: "",
  gender: "--",
  ageRange: "",
  sector: "",
  industry: "",
  country: "",
  state: "",
};

export const getOptionLabel = (options, value) =>
  options.find((option) => option.value === value)?.label || "";

export const formatPreviewDate = (value) => {
  if (!value) {
    return "--";
  }

  const [year, month, day] = value.split("-");

  if (!year || !month || !day) {
    return value;
  }

  return `${day}/${month}/${year}`;
};

// export const getImagePayloadValue = (imageAsset) => imageAsset?.file || "";

export const buildQuestionsPayload = (surveyId, questions, hashtagItems) => ({
  survey_id: surveyId,
  questions: questions.map((question) => {
    const questionPayload = {
      question_text: question.text,
      question_type: questionTypePayloadMap[question.type] || "single_select",
      // question_image: getImagePayloadValue(question.image),
      // is_required: question.type !== "Open End",
    };

    if (question.type === "Open End") {
      return questionPayload;
    }


    questionPayload.options = question.options.map((item) => ({
      option_text: item.text || "",
      option_image: "",
    }));



    // const optionTexts = question.options.map(item => item.text);
    // questionPayload.options = optionTexts;



      // question.type === "Rating"
      //   ? [1, 2, 3, 4, 5].map((rating) => ({
      //       option_text: String(rating),
      //     }))
      //   : question.options.map((option) => ({
      //       option_text: option.text,
      //       // option_image: getImagePayloadValue(option.image),
      //     }));

    return questionPayload;
  }),
  tags: hashtagItems.map((tag) => tag.replace(/^#/, "")),
});

export const SortableOption = ({
  option,
  optionIndex,
  questionId,
  updateQuestionOption,
  // updateOptionImage,
  // removeOptionImage,
  deleteOption,
}) => {
  // const optionImageInputRef = useRef(null);
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: option.id,
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} className="cs-option-item">
      <div className="cs-option-row">
        <button
          type="button"
          className="btn p-0 border-0 d-inline-flex align-items-center me-2 cs-option-drag-handle"
          aria-label={`Drag option ${optionIndex + 1}`}
          {...attributes}
          {...listeners}
        >
          <GripVertical size={20} className="cs-option-grip" />
        </button>

        <input
          type="text"
          value={option.text}
          onChange={(e) =>
            updateQuestionOption(questionId, option.id, e.target.value)
          }
          placeholder={`Option ${optionIndex + 1}`}
          className="cs-input cs-option-placeholder"
        />

        {/* <input
          type="file"
          accept=".jpg,.jpeg,.png,.webp"
          ref={optionImageInputRef}
          className="d-none"
          onChange={(e) => {
            const file = e.target.files?.[0];

            if (!file) {
              return;
            }

            updateOptionImage(questionId, option.id, file);
            e.target.value = "";
          }}
        />

        <button
          type="button"
          className={`cs-option-icon cs-option-upload-btn ${
            option.image ? "has-image" : ""
          }`}
          aria-label={`Upload image for option ${optionIndex + 1}`}
          onClick={() => optionImageInputRef.current?.click()}
        >
          <ImagePlus size={16} />
        </button> */}

        <button
          type="button"
          className="cs-option-icon cs-option-delete-btn"
          onClick={() => deleteOption(questionId, option.id)}
          aria-label={`Delete option ${optionIndex + 1}`}
        >
          <Trash2 size={18} />
        </button>
      </div>

      {/* {option.image?.preview && (
        <div className="cs-option-image-preview">
          <div className="cs-option-thumb-wrap">
            <img
              src={option.image.preview}
              alt={option.text || `Option ${optionIndex + 1}`}
              className="cs-option-thumb"
            />
            <button
              type="button"
              className="cs-option-thumb-remove"
              onClick={() => removeOptionImage(questionId, option.id)}
              aria-label={`Remove image from option ${optionIndex + 1}`}
            >
              <X size={12} />
            </button>
          </div>
        </div>
      )} */}
    </div>
  );
};
